import React from 'react';
import { Sparkles } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { playPopSound } from '../utils/soundUtils';

interface MobileControlsProps {
  onGenerateNew: () => void;
}

export function MobileControls({ onGenerateNew }: MobileControlsProps) {
  const { isDarkMode } = useTheme();

  const handleGenerateNew = () => {
    playPopSound('strong'); // Play sound effect
    onGenerateNew();
  };

  return (
    <div className="fixed bottom-4 left-0 right-0 px-4 md:hidden z-20">
      <div className="max-w-md mx-auto">
        <button
          onClick={handleGenerateNew}
          className={`w-full flex items-center justify-center space-x-3 px-6 py-4 rounded-2xl ${
            isDarkMode 
              ? 'bg-white/10 hover:bg-white/20' 
              : 'bg-black/10 hover:bg-black/20'
          } backdrop-blur-md shadow-lg transition-all duration-300 transform hover:scale-[1.02] active:scale-95 hover:shadow-xl`}
        >
          <Sparkles size={20} className={`${isDarkMode ? 'text-white' : 'text-black'} transition-transform duration-300 group-hover:rotate-12`} />
          <span className={`font-medium ${isDarkMode ? 'text-white' : 'text-black'}`}>
            Generate New Gradient
          </span>
        </button>
      </div>
    </div>
  );
}